import React from "react";
import { Header47 } from "./components/Header47";
import { AssessmentSA} from "./components/AssessmentSA";
import { SecuritySA } from "./components/SecuritySA";
import { ThreatModel } from "./components/ThreatModel";
import { SecurityMeasures } from "./components/SecurityMeasures";
import { Testimonial1 } from "./components/Testimonial1";

import { Footer2 } from "../components/shared/Footer2";
import backgroundImage from '../assets/images/SecurityKey.jpg';
import { Navbar } from "../components/shared/Navbar";

export default function Page() {
  return (
    <div className="font-noto">
      <div
       id="relume-header"  
       style={{ backgroundImage: `url(${backgroundImage})` }}
       className="bg-cover  bg-center bg-no-repeat min-h-600px]">
        <Navbar />
        <Header47 />
       </div>
       <SecuritySA />
      <AssessmentSA />
      <ThreatModel />
      <SecurityMeasures />
      <Testimonial1 />
    
      <Footer2 />
    </div>
  );
}
